import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import AddProjectTypeWorkflowRolePopup from '../Popups/ProjectType_popup_AddWorkflowRole';

interface Props {
    projectTypeId: number
}

const ProjectType_tab_WorkflowRoles: React.FC<Props> = ({ projectTypeId }) => {
    const [data, setData] = useState<any[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForItemType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [projectTypeId]);

    function getTableData() {
        DataService.get<any[]>('api/v1/ProjectTypeWorkflowRoles/ByProjectType/' + projectTypeId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/ProjectTypeWorkflowRoles/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'functionalRoleId', visible: false },
        { title: 'Name', dataProp: 'functionalRole.name', sort: 'asc' },
        { title: 'Required', dataProp: 'required', dataType: 'bool' },
        { title: 'Allow save without checkout', dataProp: 'functionalRole.allowSaveWithoutCheckout', dataType: 'bool' },
        { title: 'Begin date', dataProp: 'functionalRole.beginDate', dataType: 'date', width: 120, align: 'right' },
        { title: 'End date', dataProp: 'functionalRole.endDate', dataType: 'date', width: 120, align: 'right' },
    ];
    if (isAuthorizedForItemType(ApplicationFunctions.EditProjectType, projectTypeId)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtProjectTypeWorkflowRoles'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Workflow role'
                navigateUrl='/plm/UserManagement/FunctionalRole/'
            />
            {showPopup && <AddProjectTypeWorkflowRolePopup projectTypeId={projectTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </>
    );
}
export default ProjectType_tab_WorkflowRoles;